import React from 'react';
import SideMenu from '../Components/Layout/SideMenu';
import TopBar from '../Components/Layout/TopBar';
import PageHeader from '../Components/Common/PageHeader';
import RecentBookingsTable from '../Components/Common/RecentBookingsTable';
import BookingPageTable from '../Components/Common/BookingPageTable';

const Booking = () => {
    return ( <main>
        <SideMenu />

        <div className='DashMain'>
            <TopBar PageTitle="Bookings" />

            <div className='DashContent'>
                <PageHeader HeaderTitle="Bookings" HeaderSub="View and manage all ticket bookings" PageHeaderStyle="PageHeaderNB"/>

                <BookingPageTable />
            </div>
        </div>

    </main> );
}
 
export default Booking;